export default __webpack_public_path__ + "static/media/DaciaBlock-Regular.fb3da390.eot";